import { OptionDialog } from 'components/OptionDialog/OptionDialog';
import { useLanguage } from 'context/AppContext';
import useExitCheckOutFlowConfirm from '../hooks/useExitCheckOutFlowConfirm';
import { useVisibleCheckOutDialog } from 'hooks/useVisibleCheckOutDialog';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const CheckOutTrayNotUsedConfirmDialog = ({ isOpen, onConfirm }: Props) => {
  const lang = useLanguage()[0].CheckOutTrayNotUsedConfirmDialog;

  const exitCheckOutFlowConfirm = useExitCheckOutFlowConfirm();
  const { prevVisibleCheckOutDialog } = useVisibleCheckOutDialog();

  return (
    <OptionDialog
      open={isOpen}
      title={lang.trayNotUsedTitle}
      heading={lang.trayNotUsedBody}
      cancelLabel={lang.goBack}
      onCancel={prevVisibleCheckOutDialog}
      confirmLabel={lang.continue}
      onClose={exitCheckOutFlowConfirm}
      onBack={prevVisibleCheckOutDialog}
      onConfirm={onConfirm}
    />
  );
};
